import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field } from 'redux-form';
import { Input } from '../../common/components/formControls';
import { FormControl, Dropdown, MenuItem } from 'react-bootstrap';
import { getDefaultActiveTerm, loadUnpagedTerms } from './actions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';

const DefaultSelectionMode = {
	NONE: 'none',
	ACTIVE: 'active'		// select active year on initial load
};

const RenderMode = {
	CONTROL: 'control',
	FIELD: 'field',			// render as redux-form field
	BUTTON: 'button'
};

class SchoolYearsDropdownList extends Component {
	constructor(props) {
		super(props);
		this.handleSelectChange = this.handleSelectChange.bind(this);
	}

	componentDidMount() {
		this.props.loadUnpagedTerms();
	}

	componentWillReceiveProps(nextProps) {
		const { onChange, value, defaultSelectedId } = nextProps;

		// trigger onChange if dropdown value is set to Active year on initial load
		if (value == null && defaultSelectedId && onChange) {
			onChange(defaultSelectedId);
		}
	}

	handleSelectChange(selectedId) {
		const { onChange } = this.props;
		if (onChange) {
			onChange(selectedId);
		}
	}

	renderEmptyOption(emptyLabel) {
		return <option key='0' value=''>{emptyLabel}</option>;
	}

	renderOptions(data, activeYear) {
		return data.map(year => {
			const isActive = activeYear && year.id === activeYear.id;
			return <option key={year.id} value={year.id} className={isActive ? 'term-active' : ''}>{year.name}</option>;
		});
	}

	render() {
		const { render = RenderMode.CONTROL, data, defaultSelection = DefaultSelectionMode.NONE,
			name, value, defaultValue, onChange, hideEmptyOption, emptyLabel,
			defaultSelectedId, activeYear, ...rest } = this.props;

		const orderedData = data.sort((a, b) => a.name > b.name ? -1 : 1);
		const selectedId = value || defaultSelectedId;
		const selected = selectedId && data.find(x => x.id === selectedId);

		switch (render) {
			case RenderMode.FIELD:
				return <Field name={name || 'schoolYearId'} component={Input} componentClass='select'
					defaultValue={defaultValue || defaultSelectedId} onChange={e => this.handleSelectChange(e.target.value)} {...rest}>
					{hideEmptyOption || this.renderEmptyOption(emptyLabel)}
					{this.renderOptions(orderedData, activeYear)}
				</Field>;
			case RenderMode.BUTTON:
				return <Dropdown>
					<Dropdown.Toggle title={<span>{(selected && selected.name) || emptyLabel} <FontAwesomeIcon icon={faChevronDown} /></span>} noCaret {...rest} />
					<Dropdown.Menu className='dashboard-dropdown-menu'>
						{hideEmptyOption || <MenuItem key={0} eventKey='' onSelect={this.handleSelectChange}><span>{emptyLabel}</span></MenuItem>}
						{data.map(year => {
							const isActive = activeYear && year.id === activeYear.id;
							return <MenuItem key={year.id} eventKey={year.id} onSelect={this.handleSelectChange}>
								<span className={isActive ? 'term-active' : ''}>{year.name}</span>
							</MenuItem>;
						})}
					</Dropdown.Menu>
				</Dropdown>;
			case RenderMode.CONTROL:
			default:
				// replace value with defaultSelectedId only if value is null or undefined
				// value = 0 is the value of the empty option, don't want to override it
				return <FormControl componentClass='select' placeholder='select' value={value != null ? value : defaultSelectedId} onChange={e => this.handleSelectChange(e.target.value)} {...rest}>
					{hideEmptyOption || this.renderEmptyOption(emptyLabel)}
					{this.renderOptions(orderedData, activeYear)}
				</FormControl>;
		}
	}
}

const mapStateToProps = (state, ownProps) => {
	const {
		lookups: { schoolYears },
		entities: { terms }
	} = state;
	const activeTerm = getDefaultActiveTerm(terms);
	const activeYear = activeTerm && activeTerm.schoolYear;
	const defaultSelectedId = ownProps.defaultSelection === DefaultSelectionMode.ACTIVE && activeYear && activeYear.id.toString();

	return {
		data: Object.values(schoolYears),
		activeYear,
		defaultSelectedId
	};
};

export default connect(mapStateToProps, {
	loadUnpagedTerms
})(SchoolYearsDropdownList);